<div
  [ngbPopover]="dateInputTemplate"
  [autoClose]="false"
  style="line-height: 25px"
  class="form-control bg-gray position-relative z-index-2 pointer fs-11 h-38"
  (click)="togglePopover(dateInputPopover)"
  (shown)="loadInput()"
  #dateInputPopover="ngbPopover"
>
  @if(inputType === 'date' && model && currentDate){
  {{ currentDate | localizedDate : "dd MMM yyyy" }}
  } @else if (inputType === 'datetime' && model && currentDate) {
  {{ currentDate | localizedDate : "dd MMM yyyy  &nbsp; &nbsp;  hh:mm a" }}
  } @else if (inputType === 'time' && model && currentDate) {
  {{ currentDate | localizedDate : "hh:mm a" }}
  } @else {
  {{ "dateInput.selectDate" | translate }}
  }
</div>

<ng-template #dateInputTemplate>
  <div>
    @if(inputType === 'date' || inputType == 'datetime') {
    <div class="col-12 p-0 m-0 position-relative pb-2">
      <input
        class="form-control"
        [placeholder]="'dateInput.selectDate' | translate"
        ngbDatepicker
        (dateSelect)="onDateChange($event)"
        #dateInput="ngbDatepicker"
        [ngModel]="model"
        (ngModelChange)="onDateChange($event)"
        [minDate]="minNgbDate!"
        [maxDate]="maxNgbDate!"
        readonly
        [firstDayOfWeek]="6"
      />

      <img
        (click)="dateInput.toggle()"
        [ngClass]="{ 'date-icon-ar': isArabic, 'date-icon-en': !isArabic }"
        class="position-absolute"
        src="assets/svg/calender.svg"
        alt="calendar_image"
      />
    </div>
    } @if(inputType === 'time' || inputType == 'datetime') {
    <ngb-timepicker
      datepicker-append-to-body="true"
      [size]="'sm'"
      [(ngModel)]="timeModel"
      (ngModelChange)="onTimeChange($event)"
      [spinners]="false"
      [seconds]="false"
      [meridian]="true"
    ></ngb-timepicker>
    }
  </div>
  <div class="row py-2">
    <div class="col-12 text-end px-0">
      <button
        class="btn btn-primary mx-2"
        (click)="selectDate(dateInputPopover)"
      >
        {{ "dateInput.save" | translate }}
      </button>

      <button
        class="btn btn-outline-primary"
        (click)="canceled(dateInputPopover)"
      >
        {{ "dateInput.cancel" | translate }}
      </button>
    </div>
  </div>
</ng-template>
